import { usePostLogin } from '@repo/api/auth/usePostLogin';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input, PasswordInput } from '@/components/ui/input';
import { useLoginForm } from '@/hooks/login-form';

export function LoginForm() {
  const { mutateAsync, isPending } = usePostLogin();
  const { form, onSubmit } = useLoginForm(mutateAsync);

  return (
    <Form {...form}>
      <form className={'flex h-full w-full grow flex-col gap-7'} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <header className={'flex flex-col items-center gap-4 py-1 text-center'}>
          <div className="relative grid size-12 place-items-center">
            <img src={'/logo.png'} alt={'Better Call Paul logo'} className={'aspect-1 h-full w-full object-contain'} />
            <span aria-hidden className={'bg-brand-accent/85 dark:bg-brand-accent/75 absolute -z-10 size-60 rounded-full blur-2xl'} />
          </div>
          <div className={'flex flex-col items-center gap-1'}>
            <h1 className={'text-foreground text-2xl font-semibold'}>Zaloguj się</h1>
            <p className={'text-muted-foreground text-sm'}>Miło Cię znowu widzieć - zaloguj się.</p>
          </div>
        </header>
        <fieldset className={'flex flex-col gap-2'}>
          <FormField
            name={'email'}
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormLabel aria-label="email">Email</FormLabel>
                <FormControl>
                  <Input placeholder={'Email'} type={'email'} inputMode={'email'} autoComplete={'username'} autoCapitalize={'none'} autoCorrect={'off'} spellCheck={false} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            name={'password'}
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormLabel aria-label="password">Hasło</FormLabel>
                <FormControl>
                  <PasswordInput placeholder={'Hasło'} autoComplete={'current-password'} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </fieldset>
        <footer className={'mt-auto flex flex-col gap-3'}>
          <Button name={'submit'} type={'submit'} className={'w-full'} variant={'primary'} disabled={isPending}>
            {isPending ? 'Logowanie...' : 'Zaloguj'}
          </Button>
          <Button className={'w-full'} variant={'outline'} asChild>
            <Link to={'/auth/reset-password'}>Odzyskaj hasło</Link>
          </Button>
        </footer>
      </form>
    </Form>
  );
}
